import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { PhxTableCellMediaSize, PhxTableCellMediaType } from '../../phx-table.types';
import { PlayFilled, ErrorTriangle } from '../../../icon/icon-map';
import { PHX_TABLE_CELL_MEDIA_SIZE, PHX_TABLE_CELL_MEDIA_TYPE } from '../phx-table-cell.const';

@Component({
  selector: 'phx-table-cell-media',
  templateUrl: './phx-table-cell-media.component.html',
  styleUrls: ['./phx-table-cell-media.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'phx-table-cell-media',
    '[class.phx-table-cell-media-large]': 'phxSize === PHX_TABLE_CELL_MEDIA_SIZE.LARGE',
  },
})
export class PhxTableCellMediaComponent {
  /** Whether the cell renders an image or video thumbnail. Default `'image'`. */
  @Input() phxMediaType: PhxTableCellMediaType = PHX_TABLE_CELL_MEDIA_TYPE.IMAGE;
  /** URL of the thumbnail, or a placeholder when omitted. */
  @Input() phxThumbnailSrc: string | undefined;
  /** Alt text for the thumbnail and image preview. */
  @Input() phxAltText: string = '';
  /** Larger media URL for the hover preview; requires `phxThumbnailSrc`. */
  @Input() phxPreviewSrc: string | undefined;
  /** Thumbnail size variant. Default `'default'`; `'large'` for the bigger preset. */
  @Input() phxSize: PhxTableCellMediaSize = PHX_TABLE_CELL_MEDIA_SIZE.DEFAULT;

  public readonly PHX_TABLE_CELL_MEDIA_TYPE = PHX_TABLE_CELL_MEDIA_TYPE;
  public readonly PHX_TABLE_CELL_MEDIA_SIZE = PHX_TABLE_CELL_MEDIA_SIZE;
  public readonly PlayFilledIcon = PlayFilled;
  public readonly ErrorTriangleIcon = ErrorTriangle;
}
